module.exports = __webpack_public_path__ + "img/partner39.2d4737e1.png";